import { Select, SelectItem } from '@heroui/react';
import _ from 'lodash';
import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import type { FormControlProps } from '@/app/types/form-props.type.ts';
import type { LookupModel } from '@/app/types/lookup.type.ts';
import { useFetchAccountTypesQuery } from '@/slices/account-type-api-slice.ts';

export const AccountTypeSelect: FC<FormControlProps> = ({
  name,
  label = 'Account Type',
  displayProperty = 'description',
  ...props
}) => {
  const { data, isLoading } = useFetchAccountTypesQuery();
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: props.required ? 'This field is required' : undefined,
      }}
      render={({ field, fieldState }) => (
        <Select
          label={label}
          variant='bordered'
          isRequired={props.required}
          isDisabled={props.disabled}
          isLoading={isLoading}
          isInvalid={fieldState.invalid}
          errorMessage={fieldState.error?.message}
          items={data || []}
          selectedKeys={field.value?.id ? [field.value.id.toString()] : []}
          onSelectionChange={keys => {
            const selectedId = Array.from(keys)[0];
            if (selectedId) {
              const selectedType = data?.find(x => x.id === parseInt(selectedId as string));
              field.onChange(selectedType);
            } else {
              field.onChange(null);
            }
          }}
        >
          {(item: LookupModel) => (
            <SelectItem key={item.id.toString()} textValue={_.get(item, displayProperty)}>
              {_.get(item, displayProperty)}
            </SelectItem>
          )}
        </Select>
      )}
    />
  );
};
